import http from "V2.0/services/httpService";

const endpoint = "/sms";

function postAddToSMSThread({ assistantId, payload }) {
  return http.post(`${endpoint}/whitelabelAddToSMSThread/${assistantId}`, payload);
}

export { postAddToSMSThread };
